import { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useLocation, useHistory } from 'react-router-dom'
import { useAuth } from 'hooks'
import config from 'app/config'
import { getExpiryTimeFromUrl, getUrlWithoutExpiry } from 'utils/helpers'
import { syncUser, syncPatient, syncSharedFiles, updateSync } from 'features/sync-data/syncSlice'
import { Loader } from 'components/Loaders'
import { ConfirmationModalProvider } from 'components/ConfirmationModal/ConfirmationModalProvider'

const Index = ({ children }) => {
    const { isAuthenticated } = useAuth()
    const { signalr } = useSelector(state => state.app)
    const { status } = useSelector(state => state.sync)
    const { pathname, search, state } = useLocation()
    const history = useHistory()
    const dispatch = useDispatch()

    useEffect(() => {
        if (!isAuthenticated) {
            const path =
                pathname !== '' && pathname !== '/' && state !== 'triggerLogout'
                    ? pathname
                    : config.LANDING_PAGE_ROUTE
            const redirect = Buffer.from(path.replace('/', '') + search).toString('base64')

            window.location.href = `${config.API_BASE_URL}oauth/login?data=${redirect}`
        } else {
            if (status === 'pending' && signalr) {
                dispatch(syncUser())
                dispatch(syncPatient())
                dispatch(syncSharedFiles())
                dispatch(updateSync('completed'))
            }
            if (search) {
                const expTime = getExpiryTimeFromUrl(search.slice(1))
                if (expTime) {
                    dispatch(updateSync('pending'))
                    window.localStorage.setItem('exp', expTime)
                    history.replace(pathname + getUrlWithoutExpiry(search))
                }
            }
        }
    }, [isAuthenticated, signalr])

    return (
        <>
            {isAuthenticated ? (
                <ConfirmationModalProvider>{children}</ConfirmationModalProvider>
            ) : (
                <Loader />
            )}
        </>
    )
}

export default Index
